var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{attrs:{"id":"collapsePersonalPolicy"}},[_c('Markdown',{attrs:{"markdown":this.personalPolicy}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }